<template>
  <v-container fluid>
    <back-link-component :to="{ name: 'TaskListAsList' }" :label="$tt('feed.trajectories')" />
    <div class="aid-bg-grey mt-4 text-center py-8 rounded-lg">
      <span>{{ $tt('customShowTaskDetailError') }}</span>
    </div>
  </v-container>
</template>
<script>
export default {
  name: 'TaskDetailError',
}
</script>
